class ProductRelationsLoadingService extends BaseService
	@register angular.module 'App.Service'
	@inject '$q',
		'ProductDataRepository'
		'ProductImagesRepository'
		'ProductSkuRepository'
		'ProductTranslationRepository'
		'ProductCategoryRepository'
		'ShopRepository'
		'ShopGroupRepository'
		'AddonProductMetadataRepository'
		'BundledProductMetadataRepository'
		'ProductSuggestionRepository'
		'ProductRepository'
		'ProductVariantDataRepository'
		'ProductVariantSkuRepository'
		'ProductVariantTranslationRepository'
		'ProductFilterValueRepository'

	loadRelations: (product) ->
		variantIds =  _.pluck(product.product_variants, 'id')

		productRelationPromises = {
			deposit_product: @loadBelongsToRelation(@ProductRepository, product.deposit_product_id)
			product_data: @loadHasManyRelation(@ProductDataRepository, product.id, 'product_id'),
			product_images: @loadHasManyRelation(@ProductImagesRepository, product.id, 'product_id'),
			product_skus: @loadHasManyRelation(@ProductSkuRepository, product.id, 'product_id'),
			product_filters: @loadHasManyRelation(@ProductFilterValueRepository, product.id, 'product_id')
			translations: @loadHasManyRelation(@ProductTranslationRepository, product.id, 'owner_id'),
			product_categories: @loadManyToManyRelation(@ProductCategoryRepository, product.product_categories),
			shops: @loadManyToManyRelation(@ShopRepository, product.shops),
			shop_groups: @loadManyToManyRelation(@ShopGroupRepository, product.shop_groups),
			addon_products: @loadManyToManyRelation(@AddonProductMetadataRepository, product.addon_products),
			bundled_products: @loadManyToManyRelation(@BundledProductMetadataRepository, product.bundled_products),
			product_suggestions: @loadManyToManyRelation(@ProductSuggestionRepository, product.product_suggestions),
		}

		productVariantRelationPromises = {
			product_data: @loadVariantsRelation(@ProductVariantDataRepository, variantIds, 'product_variant_id'),
			product_variant_skus: @loadVariantsRelation(@ProductVariantSkuRepository, variantIds, 'product_variant_id'),
			translations: @loadVariantsRelation(@ProductVariantTranslationRepository, variantIds, 'owner_id'),
		}

		promises = {
			product_relations: @$q.all(productRelationPromises),
			product_variant_relations: @$q.all(productVariantRelationPromises)
		}

		return @$q
			.all(promises)
			.then (relations) =>

				for relation, entities of relations.product_relations
					product[relation] = entities

				for relation, entities of relations.product_variant_relations
					for variant in product.product_variants
						variant[relation] = entities[variant.id] ? []

				return product

	loadHasManyRelation: (repository, id, property) ->
		query = repository.createQuery()
		query.criteria(property, '=', id)

		return repository.getEntities(query)

	loadBelongsToRelation: (repository, value) ->
		if !value?
			return null

		return repository.getEntity(value, null, null)

	loadManyToManyRelation: (repository, values) ->
		if _.isEmpty(values)
			return []

		query = repository.createQuery()
		query.criteria('id', 'IN', values.join())

		return repository.getEntities(query)

	loadVariantsRelation: (repository, values, property) ->
		if _.isEmpty(values)
			return []

		query = repository.createQuery()
		query.criteria(property, 'IN', values.join())

		return repository.getEntities(query).then (entities) => _.groupBy(entities, property)
